// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact Info Styles */

.contact-info {
  padding: 40px 0;
  background: #ffffff;
  font-family: Arial, sans-serif;
}

.contact-info__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-info__grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 40px;
  align-items: start;
}

@media (max-width: 768px) {
  .contact-info__grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

.contact-info__title {
  font-size: 24px;
  font-weight: 700;
  color: #2c2c2c;
  margin-bottom: 30px;
  text-align: center;
  letter-spacing: 1px;
}

/* Левая колонка - Контактные данные */
.contact-info__left .contact-info__blocks {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.contact-info__block {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  border-left: 4px solid #4A90E2;
}

.contact-info__icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-top: 2px;
}

.contact-info__content {
  flex: 1;
}

.contact-info__label {
  font-size: 14px;
  font-weight: 600;
  color: #4A90E2;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.contact-info__value {
  font-size: 16px;
  color: #2c2c2c;
  line-height: 1.5;
  margin: 0;
  white-space: pre-line;
}

/* Стили для кликабельных ссылок */
.contact-info__link {
  color: #2c2c2c;
  text-decoration: none;
  transition: color 0.3s ease;
  display: block;
}

.contact-info__link:hover {
  color: #4A90E2;
  text-decoration: underline;
}

/* Средняя колонка - Форма */
.contact-info__form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.contact-info__form-group {
  display: flex;
  flex-direction: column;
}

.contact-info__input,
.contact-info__textarea {
  width: 100%;
  padding: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  font-family: inherit;
  transition: border-color 0.3s ease;
}

.contact-info__input:focus,
.contact-info__textarea:focus {
  outline: none;
  border-color: #4A90E2;
}

.contact-info__textarea {
  resize: vertical;
  min-height: 120px;
}

.contact-info__submit {
  padding: 15px 30px;
  background: #4A90E2;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.contact-info__submit:hover {
  background: #357abd;
}

/* Правая колонка - Социальные сети */
.contact-info__social {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-info__social-link {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  background: #f9f9f9;
  border-radius: 8px;
  text-decoration: none;
  color: #2c2c2c;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.contact-info__social-link:hover {
  background: #f0f0f0;
  transform: translateX(5px);
}

.contact-info__social-icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-info__social-icon img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.contact-info__social-text {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Цвета для разных социальных сетей */
.contact-info__social-link.tripadvisor {
  border-left-color: #00AF87;
}

.contact-info__social-link.facebook {
  border-left-color: #3b5998;
}

.contact-info__social-link.yelp {
  border-left-color: #D32323;
}

.contact-info__social-link.justeat {
  border-left-color: #FF8000;
}

.contact-info__social-link.smood {
  border-left-color: #FF6B35;
}

.contact-info__social-link.instagram {
  border-left-color: #e4405f;
}

.contact-info__social-link.twitter {
  border-left-color: #1da1f2;
}

.contact-info__social-link.youtube {
  border-left-color: #ff0000;
}

/* Hover эффекты для цветов */
.contact-info__social-link.tripadvisor:hover {
  border-left-color: #00AF87;
  box-shadow: -4px 0 0 #00AF87;
}

.contact-info__social-link.facebook:hover {
  border-left-color: #3b5998;
  box-shadow: -4px 0 0 #3b5998;
}

.contact-info__social-link.yelp:hover {
  border-left-color: #D32323;
  box-shadow: -4px 0 0 #D32323;
}

.contact-info__social-link.justeat:hover {
  border-left-color: #FF8000;
  box-shadow: -4px 0 0 #FF8000;
}

.contact-info__social-link.smood:hover {
  border-left-color: #FF6B35;
  box-shadow: -4px 0 0 #FF6B35;
}

.contact-info__social-link.instagram:hover {
  border-left-color: #e4405f;
  box-shadow: -4px 0 0 #e4405f;
}

.contact-info__social-link.twitter:hover {
  border-left-color: #1da1f2;
  box-shadow: -4px 0 0 #1da1f2;
}

.contact-info__social-link.youtube:hover {
  border-left-color: #ff0000;
  box-shadow: -4px 0 0 #ff0000;
}

/* Адаптивный дизайн */
@media screen and (max-width: 1024px) {
  .contact-info__grid {
    gap: 40px;
  }
}

@media screen and (max-width: 768px) {
  .contact-info {
    padding: 40px 0;
  }
  
  .contact-info__container {
    padding: 0 16px;
  }
  
  .contact-info__grid {
    grid-template-columns: 1fr;
    gap: 50px;
  }
  
  .contact-info__title {
    font-size: 16px;
    margin-bottom: 24px;
    text-align: center;
  }
  
  .contact-info__blocks {
    gap: 30px;
  }
  
  .contact-info__block {
    gap: 16px;
  }
  
  .contact-info__icon {
    font-size: 20px;
  }
  
  .contact-info__label {
    font-size: 13px;
  }
  
  .contact-info__value {
    font-size: 15px;
  }
  
  .contact-info__input,
  .contact-info__textarea {
    padding: 14px;
    font-size: 15px;
  }
  
  .contact-info__submit {
    width: 100%;
    padding: 14px;
    font-size: 15px;
  }
  
  .contact-info__social {
    gap: 16px;
  }
  
  .contact-info__social-link {
    padding: 14px;
  }
  
  .contact-info__social-text {
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .contact-info {
    padding: 30px 0;
  }
  
  .contact-info__grid {
    gap: 40px;
  }
  
  .contact-info__title {
    font-size: 15px;
    margin-bottom: 20px;
  }
  
  .contact-info__blocks {
    gap: 24px;
  }
  
  .contact-info__block {
    gap: 12px;
  }
  
  .contact-info__icon {
    font-size: 18px;
  }
  
  .contact-info__input,
  .contact-info__textarea {
    padding: 12px;
    font-size: 14px;
  }
  
  .contact-info__textarea {
    min-height: 100px;
  }
  
  .contact-info__submit {
    padding: 12px;
    font-size: 14px;
  }
  
  .contact-info__social-link {
    padding: 12px;
    gap: 12px;
  }
  
  .contact-info__social-icon {
    font-size: 18px;
  }
  
  .contact-info__social-text {
    font-size: 12px;
  }
}

/* Высокий контраст */
@media (prefers-contrast: high) {
  .contact-info__input,
  .contact-info__textarea {
    border-color: #333;
  }
  
  .contact-info__submit {
    background: #333;
  }
  
  .contact-info__social-link {
    border: 1px solid #333;
  }
}

/* Печать */
@media print {
  .contact-info__form,
  .contact-info__social {
    display: none;
  }
  
  .contact-info__grid {
    grid-template-columns: 1fr;
  }
}

/* Анимации */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.contact-info__block,
.contact-info__form,
.contact-info__social {
  animation: fadeInUp 0.6s ease-out;
}

.contact-info__block:nth-child(2) {
  animation-delay: 0.1s;
}

.contact-info__block:nth-child(3) {
  animation-delay: 0.2s;
}

.contact-info__block:nth-child(4) {
  animation-delay: 0.3s;
}

/* Уменьшенное движение */
@media (prefers-reduced-motion: reduce) {
  .contact-info__block,
  .contact-info__form,
  .contact-info__social {
    animation: none;
  }
  
  .contact-info__submit {
    transition: none;
  }
  
  .contact-info__submit:hover {
    transform: none;
  }
  
  .contact-info__social-link {
    transition: none;
  }
  
  .contact-info__social-link:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ContactInfo.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,sCAAsC;AACtC;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE;;IAEE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Contact Info Styles */\n\n.contact-info {\n  padding: 40px 0;\n  background: #ffffff;\n  font-family: Arial, sans-serif;\n}\n\n.contact-info__container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.contact-info__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 40px;\n  align-items: start;\n}\n\n@media (max-width: 768px) {\n  .contact-info__grid {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n}\n\n.contact-info__title {\n  font-size: 24px;\n  font-weight: 700;\n  color: #2c2c2c;\n  margin-bottom: 30px;\n  text-align: center;\n  letter-spacing: 1px;\n}\n\n/* Левая колонка - Контактные данные */\n.contact-info__left .contact-info__blocks {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.contact-info__block {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  padding: 20px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  border-left: 4px solid #4A90E2;\n}\n\n.contact-info__icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  margin-top: 2px;\n}\n\n.contact-info__content {\n  flex: 1;\n}\n\n.contact-info__label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #4A90E2;\n  margin-bottom: 8px;\n  letter-spacing: 0.5px;\n}\n\n.contact-info__value {\n  font-size: 16px;\n  color: #2c2c2c;\n  line-height: 1.5;\n  margin: 0;\n  white-space: pre-line;\n}\n\n/* Стили для кликабельных ссылок */\n.contact-info__link {\n  color: #2c2c2c;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  display: block;\n}\n\n.contact-info__link:hover {\n  color: #4A90E2;\n  text-decoration: underline;\n}\n\n/* Средняя колонка - Форма */\n.contact-info__form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.contact-info__form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.contact-info__input,\n.contact-info__textarea {\n  width: 100%;\n  padding: 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  font-family: inherit;\n  transition: border-color 0.3s ease;\n}\n\n.contact-info__input:focus,\n.contact-info__textarea:focus {\n  outline: none;\n  border-color: #4A90E2;\n}\n\n.contact-info__textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.contact-info__submit {\n  padding: 15px 30px;\n  background: #4A90E2;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.contact-info__submit:hover {\n  background: #357abd;\n}\n\n/* Правая колонка - Социальные сети */\n.contact-info__social {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.contact-info__social-link {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px 20px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  text-decoration: none;\n  color: #2c2c2c;\n  transition: all 0.3s ease;\n  border-left: 4px solid transparent;\n}\n\n.contact-info__social-link:hover {\n  background: #f0f0f0;\n  transform: translateX(5px);\n}\n\n.contact-info__social-icon {\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.contact-info__social-icon img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.contact-info__social-text {\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n/* Цвета для разных социальных сетей */\n.contact-info__social-link.tripadvisor {\n  border-left-color: #00AF87;\n}\n\n.contact-info__social-link.facebook {\n  border-left-color: #3b5998;\n}\n\n.contact-info__social-link.yelp {\n  border-left-color: #D32323;\n}\n\n.contact-info__social-link.justeat {\n  border-left-color: #FF8000;\n}\n\n.contact-info__social-link.smood {\n  border-left-color: #FF6B35;\n}\n\n.contact-info__social-link.instagram {\n  border-left-color: #e4405f;\n}\n\n.contact-info__social-link.twitter {\n  border-left-color: #1da1f2;\n}\n\n.contact-info__social-link.youtube {\n  border-left-color: #ff0000;\n}\n\n/* Hover эффекты для цветов */\n.contact-info__social-link.tripadvisor:hover {\n  border-left-color: #00AF87;\n  box-shadow: -4px 0 0 #00AF87;\n}\n\n.contact-info__social-link.facebook:hover {\n  border-left-color: #3b5998;\n  box-shadow: -4px 0 0 #3b5998;\n}\n\n.contact-info__social-link.yelp:hover {\n  border-left-color: #D32323;\n  box-shadow: -4px 0 0 #D32323;\n}\n\n.contact-info__social-link.justeat:hover {\n  border-left-color: #FF8000;\n  box-shadow: -4px 0 0 #FF8000;\n}\n\n.contact-info__social-link.smood:hover {\n  border-left-color: #FF6B35;\n  box-shadow: -4px 0 0 #FF6B35;\n}\n\n.contact-info__social-link.instagram:hover {\n  border-left-color: #e4405f;\n  box-shadow: -4px 0 0 #e4405f;\n}\n\n.contact-info__social-link.twitter:hover {\n  border-left-color: #1da1f2;\n  box-shadow: -4px 0 0 #1da1f2;\n}\n\n.contact-info__social-link.youtube:hover {\n  border-left-color: #ff0000;\n  box-shadow: -4px 0 0 #ff0000;\n}\n\n/* Адаптивный дизайн */\n@media screen and (max-width: 1024px) {\n  .contact-info__grid {\n    gap: 40px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .contact-info {\n    padding: 40px 0;\n  }\n  \n  .contact-info__container {\n    padding: 0 16px;\n  }\n  \n  .contact-info__grid {\n    grid-template-columns: 1fr;\n    gap: 50px;\n  }\n  \n  .contact-info__title {\n    font-size: 16px;\n    margin-bottom: 24px;\n    text-align: center;\n  }\n  \n  .contact-info__blocks {\n    gap: 30px;\n  }\n  \n  .contact-info__block {\n    gap: 16px;\n  }\n  \n  .contact-info__icon {\n    font-size: 20px;\n  }\n  \n  .contact-info__label {\n    font-size: 13px;\n  }\n  \n  .contact-info__value {\n    font-size: 15px;\n  }\n  \n  .contact-info__input,\n  .contact-info__textarea {\n    padding: 14px;\n    font-size: 15px;\n  }\n  \n  .contact-info__submit {\n    width: 100%;\n    padding: 14px;\n    font-size: 15px;\n  }\n  \n  .contact-info__social {\n    gap: 16px;\n  }\n  \n  .contact-info__social-link {\n    padding: 14px;\n  }\n  \n  .contact-info__social-text {\n    font-size: 13px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .contact-info {\n    padding: 30px 0;\n  }\n  \n  .contact-info__grid {\n    gap: 40px;\n  }\n  \n  .contact-info__title {\n    font-size: 15px;\n    margin-bottom: 20px;\n  }\n  \n  .contact-info__blocks {\n    gap: 24px;\n  }\n  \n  .contact-info__block {\n    gap: 12px;\n  }\n  \n  .contact-info__icon {\n    font-size: 18px;\n  }\n  \n  .contact-info__input,\n  .contact-info__textarea {\n    padding: 12px;\n    font-size: 14px;\n  }\n  \n  .contact-info__textarea {\n    min-height: 100px;\n  }\n  \n  .contact-info__submit {\n    padding: 12px;\n    font-size: 14px;\n  }\n  \n  .contact-info__social-link {\n    padding: 12px;\n    gap: 12px;\n  }\n  \n  .contact-info__social-icon {\n    font-size: 18px;\n  }\n  \n  .contact-info__social-text {\n    font-size: 12px;\n  }\n}\n\n/* Высокий контраст */\n@media (prefers-contrast: high) {\n  .contact-info__input,\n  .contact-info__textarea {\n    border-color: #333;\n  }\n  \n  .contact-info__submit {\n    background: #333;\n  }\n  \n  .contact-info__social-link {\n    border: 1px solid #333;\n  }\n}\n\n/* Печать */\n@media print {\n  .contact-info__form,\n  .contact-info__social {\n    display: none;\n  }\n  \n  .contact-info__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Анимации */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.contact-info__block,\n.contact-info__form,\n.contact-info__social {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.contact-info__block:nth-child(2) {\n  animation-delay: 0.1s;\n}\n\n.contact-info__block:nth-child(3) {\n  animation-delay: 0.2s;\n}\n\n.contact-info__block:nth-child(4) {\n  animation-delay: 0.3s;\n}\n\n/* Уменьшенное движение */\n@media (prefers-reduced-motion: reduce) {\n  .contact-info__block,\n  .contact-info__form,\n  .contact-info__social {\n    animation: none;\n  }\n  \n  .contact-info__submit {\n    transition: none;\n  }\n  \n  .contact-info__submit:hover {\n    transform: none;\n  }\n  \n  .contact-info__social-link {\n    transition: none;\n  }\n  \n  .contact-info__social-link:hover {\n    transform: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
